import request from '../utils/request'
import { showLoadingToast,closeToast,showToast } from 'vant';
import { getToken} from '@/utils/auth'
import { goLink,openUrl } from '@/utils'


//  初始化接口
export function getSixWord(params) {
  return request({
    url: '/app-api/biz/open/getSixWord',
    method: 'get',
    params,
  })
}

export function getHomeWordPage(params) {
  return request({
    url: '/app-api/biz/open/getHomeWordPage',
    method: 'get',
    params,
  })
}

export function getBannerPage(params) {
  return request({
    url: '/app-api/biz/open/getBannerPage',
    method: 'get',
    params,
  })
}

export function postlogin(data) {
  showLoadingToast({
    duration:0,
    message: '登录中...',
    forbidClick: true,
  });
  return request({
    url: '/app-api/member/auth/login',
    method: 'post',
    data,
  })
}

export function smsRegister(data) {
  showLoadingToast({
    duration:0,
    message: '注册中...',
    forbidClick: true,
  });
  return request({
    url: '/app-api/member/auth/sms-register',
    method: 'post',
    data,
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/app-api/member/auth/send-sms-code',
    method: 'post',
    data,
  })
}

export function getWord(params) {
  return request({
    url: '/app-api/biz/open/getWord',
    method: 'get',
    params,
  })
}

export function getWordGrade(params) {
  return request({
    url: '/app-api/biz/open/getWordGrade',
    method: 'get',
    params,
  })
}

export function getWordPage(params) {
  return request({
    url: '/app-api/biz/open/getWordPage',
    method: 'get',
    params,
  })
}

export function getWordTypePage(params) {
  return request({
    url: '/app-api/biz/open/getWordTypePage',
    method: 'get',
    params,
  })
}

export function getWordTextbookPage(params) {
  return request({
    url: '/app-api/biz/open/getWordTextbookPage',
    method: 'get',
    params,
  })
}

export function getWordUnitPage(params) {
  return request({
    url: '/app-api/biz/open/getWordUnitPage',
    method: 'get',
    params,
  })
}

export function getWordGradePage(params) {
  return request({
    url: '/app-api/biz/open/getWordGradePage',
    method: 'get',
    params,
  })
}

//加入/移除学习计划
export function joinStudyPlan(params) {
// if(!getToken()){
//   showToast('请先登录')
//   setTimeout(()=>{
//     goLink('/login')
//   },500)
//   return 
// }
  showLoadingToast({
    duration:0,
    message: '加入中...',
    forbidClick: true,
  });
  return request({
    url: '/app-api/biz/open/joinStudyPlan',
    method: 'get',
    params,
  })
}


export function getUserSearchPage(params) {
  return request({
    url: '/app-api/biz/open/getUserSearchPage',
    method: 'get',
    params,
  })
}

export function clearUserSearch(params) {
  return request({
    url: '/app-api/biz/open/clearUserSearch',
    method: 'get',
    params,
  })
}

export function clearUserSearchAll(params) {
  return request({
    url: '/app-api/biz/open/clearUserSearchAll',
    method: 'get',
    params,
  })
}

export function getUserInfo(params) {
  return request({
    url: '/app-api/member/user/get',
    method: 'get',
    params,
  })
}

export function likeWord(params) {
  return request({
    url: '/app-api/biz/open/likeWord',
    method: 'get',
    params,
  })
}

export function getUserWordLikePage(params) {
  return request({
    url: '/app-api/biz/open/getUserWordLikePage',
    method: 'get',
    params,
  })
}

export function getUserWordWrongPage(params) {
  return request({
    url: '/app-api/biz/open/getUserWordWrongPage',
    method: 'get',
    params,
  })
}

export function getParentName(params) {
  return request({
    url: '/app-api/biz/open/getParentName',
    method: 'get',
    params,
  })
}

export function getUserStudyPlanPage(params) {
  return request({
    url: '/app-api/biz/open/getUserStudyPlanPage',
    method: 'get',
    params,
  })
}


export function updateUserInfo(data) {
    showLoadingToast({
      duration:0,
      message: '保存中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/member/user/update',
      method: 'put',
      data,
    })
  }

 export function updateInvite(data) {
    return request({
      url: '/app-api/member/user/update-invite',
      method: 'put',
      data,
    })
  } 

  export function uploadImg(data) {
    showLoadingToast({
      duration:0,
      message: '上传中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/infra/file/upload',
      method: 'post',
      data,
    })
  } 

  export function Loginout(data){
    showLoadingToast({
      duration:0,
      message: '退出中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/member/auth/logout',
      method: 'post',
      data,
    })
  }

  export function updatePassword(data) {
    showLoadingToast({
      duration:0,
      message: '保存中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/member/user/update-password',
      method: 'put',
      data,
    })
  }

   export function updateCard(data) {
    showLoadingToast({
      duration:0,
      message: '保存中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/biz/open/updateCard',
      method: 'put',
      data,
    })
  }


  export function resetPassword(data) {
    showLoadingToast({
      duration:0,
      message: '提交中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/member/user/reset-password',
      method: 'put',
      data,
    })
  }  

  export function getUserStudyList(params) {
    return request({
      url: '/app-api/biz/open/getUserStudyList',
      method: 'get',
      params,
    })
  }

  export function getMyClearRanking(params) {
    return request({
      url: '/app-api/biz/open/getMyClearRanking',
      method: 'get',
      params,
    })
  }

  
  export function getLevelPage(params) {
    return request({
      url: '/app-api/biz/open/getLevelPage',
      method: 'get',
      params,
    })
  }

  export function getUserCount(params) {
    return request({
      url: '/app-api/biz/open/getUserCount',
      method: 'get',
      params,
    })
  }

  export function getUserStudy(params) {
    return request({
      url: '/app-api/biz/open/getUserStudy',
      method: 'get',
      params,
    })
  }

  export function createUserStudy(params) {
    return request({
      url: '/app-api/biz/open/createUserStudy',
      method: 'get',
      params,
    })
  }

  export function getClearRanking(params) {
    return request({
      url: '/app-api/biz/open/getClearRanking',
      method: 'get',
      params,
    })
  }

  export function sendClearScore(params) {
    return request({
      url: '/app-api/biz/open/sendClearScore',
      method: 'get',
      params,
    })
  }

  export function wordStudyRecord(data) {
    return request({
      url: '/app-api/biz/open/wordStudyRecord',
      method: 'post',
      data,
    })
  } 

  export function againStudy(params) {
    return request({
      url: '/app-api/biz/open/againStudy',
      method: 'get',
      params,
    })
  }

   export function listenToWrite(data) {
    return request({
      url: '/app-api/biz/open/listenToWrite',
      method: 'post',
      data,
    })
  }
  
   export function wordCorrection(params) {
    return request({
      url: '/app-api/biz/open/wordCorrection',
      method: 'get',
      params,
    })
  }

   export function getWordIds(params) {
    return request({
      url: '/app-api/biz/open/getWordIds',
      method: 'get',
      params,
    })
  }

   export function addWrongStudyWord(data) {
    return request({
      url: '/app-api/biz/open/addWrongStudyWord',
      method: 'post',
      data,
    })
  }

   export function getWordsDayCount(params) {
    return request({
      url: '/app-api/biz/open/getWordsDayCount',
      method: 'get',
      params,
    })
  }

  export function getWordsWeekCount(params) {
    return request({
      url: '/app-api/biz/open/getWordsWeekCount',
      method: 'get',
      params,
    })
  }

   export function getWordsMonthCount(params) {
    return request({
      url: '/app-api/biz/open/getWordsMonthCount',
      method: 'get',
      params,
    })
  }

  export function getAchievement(params) {
    return request({
      url: '/app-api/biz/open/getAchievement',
      method: 'get',
      params,
    })
  }

    export function getWordStudyScore(params) {
    return request({
      url: '/app-api/biz/open/getWordStudyScore',
      method: 'get',
      params,
    })
  }

  export function exchangeCode(params) {
    return request({
      url: '/app-api/biz/open/exchangeCode',
      method: 'get',
      params,
    })
  }

    export function getDistribution(params) {
    return request({
      url: '/app-api/biz/open/getDistribution',
      method: 'get',
      params,
    })
  }

   export function getDistributionPage(params) {
    return request({
      url: '/app-api/biz/open/getDistributionPage',
      method: 'get',
      params,
    })
  }

  export function getDistributorCodePage(params) {
    return request({
      url: '/app-api/biz/open/getDistributorCodePage',
      method: 'get',
      params,
    })
  }

  export function getPdfFile(params) {
    return request({
      url: '/app-api/biz/open/getPdfFile',
      method: 'get',
      params,
    })
  }

  export function getPdfFilePage(params) {
    return request({
      url: '/app-api/biz/open/getPdfFilePage',
      method: 'get',
      params,
    })
  }

  export function getConvention(params) {
    return request({
      url: '/app-api/biz/open/getConvention',
      method: 'get',
      params,
    })
  }

  export function getAgreement(params) {
    return request({
      url: '/app-api/biz/open/getAgreement',
      method: 'get',
      params,
    })
  }

  export function getMyTeam(params) {
    return request({
      url: '/app-api/biz/open/getMyTeam',
      method: 'get',
      params,
    })
  }

  
  export function getMySuperior(params) {
    return request({
      url: '/app-api/biz/open/getMySuperior',
      method: 'get',
      params,
    })
  }

   export function getMyRevenue(params) {
    return request({
      url: '/app-api/biz/open/getMyRevenue',
      method: 'get',
      params,
    })
  }

   export function getMyDistributor(params) {
    return request({
      url: '/app-api/biz/open/getMyDistributor',
      method: 'get',
      params,
    })
  }

   export function getMyAmount(params) {
    return request({
      url: '/app-api/biz/open/getMyAmount',
      method: 'get',
      params,
    })
  }

  export function getAllWithdrawal(params) {
    return request({
      url: '/app-api/biz/open/getAllWithdrawal',
      method: 'get',
      params,
    })
  }

   export function getDistributorApplyPage(params) {
    return request({
      url: '/app-api/biz/open/getDistributorApplyPage',
      method: 'get',
      params,
    })
  }

  export function updateShareRatio(params) {
    return request({
      url: '/app-api/biz/open/updateShareRatio',
      method: 'get',
      params,
    })
  }

  export function getUserWithdrawalPage(params) {
    return request({
      url: '/app-api/biz/open/getUserWithdrawalPage',
      method: 'get',
      params,
    })
  }

  export function createUserWithdrawal(data) {
    showLoadingToast({
      duration:0,
      message: '保存中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/biz/open/createUserWithdrawal',
      method: 'post',
      data,
    })
  }

    export function createDistributorApply(data) {
    showLoadingToast({
      duration:0,
      message: '提交中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/biz/open/createDistributorApply',
      method: 'post',
      data,
    })
  }

   export function updateDistributorApply(data) {
    showLoadingToast({
      duration:0,
      message: '提交中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/biz/open/updateDistributorApply',
      method: 'post',
      data,
    })
  }

  export function CreateLevelOrder(params) {
    return request({
      url: '/app-api/biz/order/create-level-order',
      method: 'get',
      params,
    })
  }
  
   export function createDistributorOrder(params) {
    return request({
      url: '/app-api/biz/order/create-distributor-order',
      method: 'get',
      params,
    })
  }

  export function getOrder(params) {
    return request({
      url: '/app-api/biz/order/getOrder',
      method: 'get',
      params,
    })
  }

   export function orderSubmit(data) {
    showLoadingToast({
      duration:0,
      message: '提交中...',
      forbidClick: true,
    });
    return request({
      url: '/app-api/pay/order/submit',
      method: 'post',
      data,
    })
  }

   export function wxSignature(data) {
    return request({
      url: '/app-api/member/auth/create-weixin-jsapi-signature?url='+data.url,
      method: 'post',
      data,
    })
  }

  